import React, {useEffect, useState} from "react";
import {Col, Form, Row} from "react-bootstrap";
import {makeStyles} from "@material-ui/core/styles";
import {translation} from "../../../../I18n/i18n";
import FormField from "../../../UI/FormField/FormField";
import Selector from "../../../UI/Selector/Selector";

const PersonalInformation = (props) => {
    const [firstname, setFirstname] = useState ("");
    const [firstnameIsInvalid, setFirstnameIsInvalid] = useState (false);
    const [surname, setSurname] = useState ("");
    const [surnameIsInvalid, setSurnameIsInvalid] = useState (false);
    const [gender, setGender] = useState ("");
    const [responsibility, setResponsibility] = useState (props.element ? props.element.Headline.Description.Label._text : "");
    const [mail, setMail] = useState ("");
    const useStyles = makeStyles ((theme) => ({
        required: {
            color: '#da2130!important',
            paddingLeft: '5px'
        },

    }));
    const classes = useStyles ();
    useEffect (() => {
        if (props.element) {
            setFirstname (props.element.Identification.PersonName.FirstName._text)
            setSurname (props.element.Identification.PersonName.Surname._text)
            setGender (props.element.Identification.Demographics.Gender.Code._text);
            setMail (props.element.Identification.ContactInfo.Email.Contact._text);
        }
    }, [props.element])

    let handleChangeMail = (value, manuallyChanged) => {
        if (manuallyChanged) {
            let u = findUser (value)
            u && props.setUserId (u.id)
        }

        setMail (value)
        props.element.Identification.ContactInfo.Email.Contact._text = value

        props.mandatoryInformationFilled (checkMandatory (props.element.Identification))
    }

    let handleChangeFirstName = (value) => {
        setFirstname (value)
        props.element.Identification.PersonName.FirstName._text = value
        setFirstnameIsInvalid(containsAnyOf (value, `"*:<>?/|\\`)) ;
        props.mandatoryInformationFilled (checkMandatory (props.element.Identification))
    }

    let handleChangeSurname = (value) => {
        setSurname (value)
        props.element.Identification.PersonName.Surname._text = value
        setSurnameIsInvalid(containsAnyOf (value, `"*:<>?/|\\`)) ;
        props.mandatoryInformationFilled (checkMandatory (props.element.Identification))
    }

    let handleChangeResponsibility = v => {
        setResponsibility (v)
        props.element.Headline.Description.Label._text = v
    }

    let lower = text => text ? text.toLowerCase () : text

    let findUser = email => props.allUsers.find (el => lower (el.mail) === lower (email))

    let isFilled = value => {
        return Object.keys (value).length > 0 && value._text !== ""
    }

    let [isValidUser, setIsValidUser] = useState (true)

    let checkMandatory = identification => {
        let r = checkValidUser (identification)
        setIsValidUser(r)
        return r && 
        (isFilled (identification.PersonName.FirstName)  
            && !containsAnyOf (identification.PersonName.FirstName._text, `"*:<>?/|\\`)  
            && !containsAnyOf (identification.PersonName.Surname._text, `"*:<>?/|\\`))  
        && 
            isFilled (identification.PersonName.Surname) || (!props.isAdminMember && !props.isHrMember)

    }

    let containsAnyOf = (text, unwanted) => {
        if(text){
            return text.split ("").some (c => unwanted.indexOf (c) !== -1)
        }
        return false;
    }

    let checkValidUser = identification => {
        return props.userId !== "" &&
            isFilled (identification.ContactInfo.Email.Contact) &&
            findUser (identification.ContactInfo.Email.Contact._text)
    }

    let handleSelect = p => {
        if (p && p.mail && p.id) {
            props.setUserId (p.id)
            handleChangeMail (p.mail, false)

            if (props.isNewCV && p.givenName && p.surname) {
                handleChangeFirstName (p.givenName)
                handleChangeSurname (p.surname)
            } 
        }
    }

    return (
        <Form>
            <Form.Group as={ Row }>
                <Form.Label required column sm="3">
                    { translation (props.lang, "Email") }
                    <span className={ classes.required }>*</span>
                </Form.Label>

                <Col sm="9">
                    <Selector value={ mail }
                              onChange={ (v) => handleChangeMail (v, true) }
                              disabled={ !props.isAdminMember && !props.isHrMember }
                              onSelect={ handleSelect }
                              allUsers={ props.allUsers }
                              access_token={props.token}
                              isInvalid={ !isValidUser && (props.isAdminMember || props.isHrMember) }
                              controlFeedback={ translation (props.lang, "Please select a user from the list") }
                              lang={ props.lang }
                    />
                </Col>
            </Form.Group>

            <FormField
                dict={ props.dict }
                notify={ props.notify }
                addToDictionary={ props.addToDictionary }
                lang={ props.lang }
                label={ translation (props.lang, "First name") } isRequired value={ firstname }
                isInvalid={ firstnameIsInvalid }
                feedback={ `${ translation(props.lang, "Enter a name that does not contain any of these characters")} " * : < > ? / | \\` }
                disabled={ !props.isNewCV && !props.isAdminMember && !props.isHrMember }
                onChange={ handleChangeFirstName }/>

            <FormField
                notify={ props.notify }
                dict={ props.dict }
                addToDictionary={ props.addToDictionary }
                lang={ props.lang }
                label={ translation (props.lang, "Last name") } isRequired value={ surname }
                isInvalid={ surnameIsInvalid }
                feedback={ `${ translation(props.lang, "Enter a name that does not contain any of these characters")} " * : < > ? / | \\` }
                disabled={ !props.isNewCV && !props.isAdminMember && !props.isHrMember }
                onChange={ handleChangeSurname }/>

            <FormField
                dict={ props.dict }
                notify={ props.notify }
                addToDictionary={ props.addToDictionary }
                lang={ props.lang }
                label={ translation (props.lang, "Function") } value={ responsibility }
                onChange={ handleChangeResponsibility }/>

            <Form.Group as={ Row }>
                <Form.Label column sm="3">
                    { translation (props.lang, "Gender") }
                </Form.Label>
                <Col sm="9">
                    <Form.Control
                        as="select"
                        value={ gender }
                        disabled={ false }
                        onChange={ (e) => {
                            props.element.Identification.Demographics.Gender.Code._text = e.target.value;
                            setGender (e.target.value)
                        } }
                    >
                        <option value="M">{ translation (props.lang, "Male") } </option>
                        <option value="F"> { translation (props.lang, "Female") }</option>
                        <option value=""> { translation (props.lang, "Do not indicate") }</option>
                    </Form.Control>
                </Col>
            </Form.Group>
        </Form>
    );
};

export default PersonalInformation;
